export default __webpack_public_path__ + "static/media/accent_image.0800ec74.jpg";